module.exports = __webpack_public_path__ + "img/company-features.63e833d0.svg";